import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

import killbillReducer from "./killbillReducer";

const rootReducer = combineReducers({
  killbillReducer,
  routing: routerReducer,
});

export default rootReducer;
